module.exports = __webpack_public_path__ + "media/src/assets/Images/CarouselSecond-52acddf46646795cf6fb2079d00e82b5.jpg";